import { Component, OnInit, HostListener, ViewEncapsulation, AfterViewInit, OnDestroy, Input, OnChanges, SimpleChanges} from '@angular/core';
import { BannerService } from '../services/banner.service';
import { environment } from '../../environments/environment';
import * as _ from 'underscore';
import * as $ from 'jquery';
window['$'] = window['jQuery'] = $;
import 'bootstrap-sass/assets/javascripts/bootstrap.js';
import 'jquery-touchswipe/jquery.touchSwipe.min.js';
import { EmitterService } from '../services/emitter.service';
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { NavigationEnd, NavigationStart, Router } from '@angular/router';

@Component({
  selector: 'app-carousel-banner',
  templateUrl: './carousel-banner.component.html',
  styleUrls: ['./carousel-banner.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CarouselBannerComponent implements AfterViewInit, OnDestroy, OnChanges {
  bannersHomePage1;
  windowType;
  imagePath;
  @Input()
  langCode;
  @Input() seoBannerContent;
  seoBannerContentVal;
  isToShowBanner = false;
  homepageCarouselContent: any[];
  xDown = null;
  yDown = null;

  bannersAvailable:boolean=false;

  carouselAutoPlay;
  activeItem:number=1;
  sliderItemLength:number=0;
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private bannerService: BannerService,
    private emitterService: EmitterService,
    private router: Router,
  ) {
    this.langCode = localStorage.getItem('langCode')
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode => {
      this.langCode = langCode;
      this.showTabsContent(this.seoBannerContentVal);
    })
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((evt) => {
      if (evt instanceof NavigationStart) {
        this.isToShowBanner = false;
      } else if (evt instanceof NavigationEnd) {
        this.showTabsContent(this.seoBannerContentVal);
      }
    });
  }
  @HostListener('window:resize') onResize() {
    const ww = document.body.clientWidth;
    if (ww <= 767) {
      this.windowType = "mobile";
    } else {
      this.windowType = "device";
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes["seoBannerContent"]) {
      this.seoBannerContentVal = changes["seoBannerContent"]["currentValue"];
      this.showTabsContent(this.seoBannerContentVal);
    }
  }

  ngAfterViewInit() {
    this.showTabsContent(this.seoBannerContentVal);
  }

  showTabsContent(bannerData) {
    if(bannerData) {
      this.seoBannerContentVal = bannerData.replace(new RegExp('{{siteUrl}}', 'g'), environment.siteUrl);
      this.isToShowBanner = true;
      setTimeout(() => {
        $("#bannerContent").html(this.seoBannerContentVal);
        this.showTabsClickEvent();
        this.accordian();
      });
    }else {
      this.isToShowBanner = false;
    }
  }

  showTabsClickEvent() {
    $(".tabs_list li").unbind('click').bind('click', function() {
      let id = $(this).attr("data-id");
      $(".tabs_list li, .tab_content").removeClass("active");
      $(this).addClass("active");
      $('#'+id).addClass("active");
    })
  }

  accordian() {
    $(".accordian-title").unbind('click').bind('click', function() {
      if($(this).siblings('.accordian-content').is(':hidden') === true) {
        $(this).parents(".accordian_wrap").find(".accordian").removeClass("show-accordian");
        $(this).parent('.accordian').addClass("show-accordian");
      } else {
        $(this).parent('.accordian').removeClass("show-accordian");
      }
    })
  }

  

 
  loadhome2Banners(): void {

    let self = this;
    
    this.bannersAvailable=false;
    
    Promise.resolve(this.bannerService.getBanners({ 'zoneId': '6' }))
      .then(
        banners => {
          

          if (banners && banners.length > 0) {
            
            setTimeout(() => {
              
              // banners= banners;
              let bannersTest = [banners[0]];
              _.each(bannersTest, function (banner) {
                banner.content = banner.content.replace(new RegExp('{{siteUrl}}', 'g'), environment.siteUrl);
              })
              this.bannersHomePage1 = bannersTest;
              this.homepageCarouselContent = banners[0].content;

              $("#carousel-innerhtml").html(this.homepageCarouselContent);
              

              let sliderItems = document.querySelectorAll("#myCarousel .item");
              if(sliderItems.length > 1){
                let itemIndicators = "";
                
                sliderItems.forEach((item,index)=>{
                  itemIndicators+=`<li data-index="${index+1}"> </li>`;
                });

                document.querySelector('#myCarousel .carousel-indicators').innerHTML=itemIndicators;

                //Making first Item as Default
                document.querySelector(`#myCarousel .item:nth-child(1)`).classList.add('active');
                document.querySelector(`#myCarousel .carousel-indicators li:nth-child(1)`).classList.add('active');

              }
              this.bannersAvailable=true;
              this.carouselInit();

            });
          } else {
            this.bannersHomePage1 = banners;
          }
          
        }
      )
  }

  carouselInit(){

    if(this.carouselAutoPlay){
      this.activeItem=1;
      this.sliderItemLength=0;
      clearInterval(this.carouselAutoPlay);
    }

    this.sliderItemLength=document.querySelectorAll("#myCarousel .item").length;

    if(this.sliderItemLength>1){

      this.carouselAutoPlay = setInterval(()=>{


        // clear active class for li

        document.querySelectorAll("#myCarousel .item.active").forEach(function(element) {
            element.classList.remove("active");
        });

        document.querySelectorAll("#myCarousel .carousel-indicators li.active").forEach(function(element) {
            element.classList.remove("active");
        });
        
        let nextItem=this.activeItem+1;
        nextItem>this.sliderItemLength?this.activeItem=1:this.activeItem=nextItem;

        document.querySelector(`#myCarousel .item:nth-child(${this.activeItem})`).classList.add('active');
        document.querySelector(`#myCarousel .carousel-indicators li:nth-child(${this.activeItem})`).classList.add('active');
  
      },4000);


      let indicators = document.querySelectorAll('#myCarousel .carousel-indicators li');

      indicators.forEach((indicator,index)=>{

        indicator.addEventListener('click',(e)=>{
          let liElement=e.target as Element;
          const liIndex=liElement.getAttribute('data-index');
          
          this.activeItem=parseInt(liIndex);

          document.querySelectorAll("#myCarousel .item.active").forEach(function(element) {
              element.classList.remove("active");
          });

          document.querySelectorAll("#myCarousel .carousel-indicators li.active").forEach(function(element) {
              element.classList.remove("active");
          });

          document.querySelector(`#myCarousel .item:nth-child(${this.activeItem})`).classList.add('active');
          document.querySelector(`#myCarousel .carousel-indicators li:nth-child(${this.activeItem})`).classList.add('active');

        });


      })

    }

  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();

    if(this.carouselAutoPlay){
      this.activeItem=1;
      this.sliderItemLength=0;
      clearInterval(this.carouselAutoPlay);
    }
  }

}
